import { getLuminance } from 'polished';

export const generateId = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const getAvatarInitials = (fullname: string | undefined | null): string => {
  const name = (fullname ?? '').trim();

  if (!name) return '';

  const parts = name.split(/\s+/).filter(Boolean);

  if (parts.length > 1) {
    const first = parts[0];
    const last = parts[parts.length - 1];

    return `${first[0] ?? ''}${last[0] ?? ''}`.toUpperCase();
  }

  const word = parts[0] ?? '';

  if (word.length >= 2) return `${word[0]}${word[1]}`.toUpperCase();

  return (word[0] ?? '').toUpperCase();
};

export const getColorTone = (backgroundColor: string | undefined | null, threshold = 0.6): 'light' | 'dark' => {
  if (!backgroundColor) return 'dark';

  try {
    const luminance = getLuminance(backgroundColor);

    return luminance > threshold ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
};
